import Vue from 'vue'
import VueMeta from 'vue-meta'
import VueLazyload from 'vue-lazyload'
import VueWaypoint from 'vue-waypoint'
import VuePlyr from 'vue-plyr'
import VueAnalytics from 'vue-analytics'
import App from './App.vue'
import router from '@/router'
import store from '@/store'

import '@/css/tailwind.styl'

Vue.config.productionTip = false

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})

Vue.use(VueLazyload, {
  preLoad: 2
})

Vue.use(VueWaypoint)

Vue.use(VueAnalytics, {
  id: 'UA-119874440-2',
  disabled: true
})

Vue.use(VuePlyr, {
  plyr: {
    fullscreen: { enabled: false }
  },
  emit: ['ended']
})

router.afterEach(() => {
  setTimeout(() => {
    store.commit('DISABLE_INTRO')
  }, 100)
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
